const EditionPanelVariants = {
  HOMEPAGE: 'HOMEPAGE',
  CHAPTER: 'CHAPTER',
  QUIZ: 'QUIZ',
};

export default EditionPanelVariants;
